import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAdminSession } from '../../security';

interface StandardStoreGuardProps {
  children: ReactNode;
  // When true, a missing `kind` param is treated as the Standard Store (Collections),
  // matching ShopExplorePage where anything that isn't `custom` renders the exclusive view.
  defaultExclusive?: boolean;
}

// The Standard Store (ready-to-wear, `kind=exclusive`) is admin-only pre-launch.
// Non-admins hitting an exclusive URL directly are bounced home; every other kind
// (custom, or the mixed default catalog) passes through untouched.
export default function StandardStoreGuard({ children, defaultExclusive = false }: StandardStoreGuardProps) {
  const location = useLocation();
  const kind = new URLSearchParams(location.search).get('kind');
  const isExclusive = kind === 'exclusive' || (defaultExclusive && kind !== 'custom');

  if (isExclusive && !isAdminSession()) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
